//  import test from './components/test';
import scrollToHash from './components/scrollToHash';
import googleMaps from './components/googleMaps';
import archivePopup from './components/archivePopup';
import slider from './components/slider';
import headerSticky from './components/headerSticky';
import hamburger from './components/hamburger';
import teampopup from './components/teampopup';

$(function() {
    // Handler for .ready() called.
    scrollToHash.init();
    headerSticky.init();
    hamburger.init();
    googleMaps.init();
    archivePopup.init();
    slider.init();
    teampopup.init();
});